import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, ChevronLeft, ChevronRight } from 'lucide-react';
const previewImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/ihrrwTdxyqK4L6wkGDbRCH/1f612048-5d5d-46ae-bd77-1b828c4438aa.png',
  alt: 'Atlas Visual de Instrumental Quirúrgico - Pinzas hemostáticas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7MSdMF7AuNjuwCMfTJntxP/IMG_4849.jpg',
  alt: 'Instrumental quirúrgico esencial - Guía de referencia rápida'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/j39KUBiLBf3cjWrQixUEyv/IMG_4850.jpg',
  alt: 'Vocabulario quirúrgico esencial'
}];
export const BookPreview: React.FC = () => {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const total = previewImages.length;
  const paginate = (newDirection: number) => {
    setDirection(newDirection);
    setIndex(prev => (prev + newDirection + total) % total);
  };
  const goTo = (i: number) => {
    setDirection(i > index ? 1 : -1);
    setIndex(i);
  };
  const slideVariants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 300 : -300,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -300 : 300,
      opacity: 0
    })
  };
  return <section className="w-full bg-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-38">
      <div className="max-w-md sm:max-w-lg mx-auto" data-id="element-39">
        <div className="text-center mb-6" data-id="element-40">
          <div className="inline-flex items-center gap-2 bg-cyan-50 text-cyan-700 px-4 py-2 rounded-full font-semibold text-xs mb-3 border border-cyan-100" data-id="element-41">
            <BookOpen className="w-3.5 h-3.5" data-id="element-42" />
            <span data-id="element-43">VISTA PREVIA</span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900" data-id="element-44">
            Interior del <span className="text-cyan-700" data-id="element-45">ebook</span>
          </h2>
          <p className="text-slate-500 text-sm mt-2" data-id="element-46">
            Deslizá para ver páginas reales del Atlas.
          </p>
        </div>

        {/* Carousel */}
        <div className="relative" data-id="element-47">
          <div className="relative bg-slate-50 rounded-2xl overflow-hidden border border-slate-200 shadow-md aspect-[3/4]" data-id="element-48">
            <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-49">
              <motion.div key={index} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
              x: {
                type: 'spring',
                stiffness: 300,
                damping: 30
              },
              opacity: {
                duration: 0.2
              }
            }} drag="x" dragConstraints={{
              left: 0,
              right: 0
            }} dragElastic={0.6} onDragEnd={(_, info) => {
              const swipe = info.offset.x;
              if (swipe < -50) {
                paginate(1);
              } else if (swipe > 50) {
                paginate(-1);
              }
            }} className="absolute inset-0 flex items-center justify-center cursor-grab active:cursor-grabbing" data-id="element-50">
                <img src={previewImages[index].src} alt={previewImages[index].alt} draggable={false} className="w-full h-full object-contain select-none p-2" data-id="element-51" />
              </motion.div>
            </AnimatePresence>

            {/* Arrows (hidden on small screens, where swipe is primary) */}
            <button onClick={() => paginate(-1)} aria-label="Anterior" className="hidden sm:flex absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-md text-slate-700 transition-all" data-id="element-52">
              <ChevronLeft className="w-5 h-5" data-id="element-53" />
            </button>
            <button onClick={() => paginate(1)} aria-label="Siguiente" className="hidden sm:flex absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-md text-slate-700 transition-all" data-id="element-54">
              <ChevronRight className="w-5 h-5" data-id="element-55" />
            </button>

            {/* Counter pill */}
            <div className="absolute top-3 right-3 bg-slate-900/70 text-white text-xs font-semibold px-2.5 py-1 rounded-full backdrop-blur-sm" data-id="element-56">
              {index + 1} / {total}
            </div>
          </div>

          {/* Instagram-style dots */}
          <div className="flex justify-center items-center gap-2 mt-4" data-id="element-57">
            {previewImages.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Ir a la imagen ${i + 1}`} className={`transition-all duration-300 rounded-full ${i === index ? 'w-2.5 h-2.5 bg-cyan-600' : 'w-2 h-2 bg-slate-300 hover:bg-slate-400'}`} data-id="element-58" />)}
          </div>
        </div>
      </div>
    </section>;
};